module.exports = __webpack_public_path__ + "img/route.f70e3ab7.svg";